import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const AddMetricButton = ({
  'data-test-id': dataTestId,
  disabledReason = '',
  onClick,
  hidden = false
}) => {
  if (hidden) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledReason,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": dataTestId,
      disabled: !!disabledReason,
      use: "transparent",
      onClick: onClick,
      marginBlockStart: "400",
      marginInlineStart: "0",
      paddingInlineStart: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.metrics-editor-dropdown.config.addMetric"
      })
    })
  });
};
export default AddMetricButton;